import {Component, ElementRef, EventEmitter, Input, OnInit, ViewChild} from "@angular/core";
import { Output } from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {UploaderOptions, UploadFile, UploadInput, UploadOutput} from "ngx-uploader";
import {environment} from "../../../../environments/environment";
import {AuthService} from "../../../services/auth/auth-service";
import {ServiceCopyControllerService} from "../../../services/service-controller/service-copy-controller.service";
import {BaseError} from "../base-error";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "service-file-uploader",
  templateUrl: "service-file-uploader.component.html",
})
export class ServiceFileUploaderComponent extends BaseError implements OnInit {

  @Input() public serviceUrl: string;
  private baseUrl: string = environment.BASE_URL;
  public serviceId: string;
  @Input() public buttonLabel: string;
  @Input() public hideIcon: boolean;
  @Input() public simpleButton: boolean;
  public options: UploaderOptions;
  public formData: FormData;
  public files: UploadFile[];
  public uploadInput: EventEmitter<UploadInput>;
  @Output() public fileIdChanged: EventEmitter<any>;
  @ViewChild("fileInput") public fileInput: ElementRef;
  public dragOver: boolean;
  public catalogData: any;
  public serviceCopyId: string;
  public showImportServiceModal: any = { value: false };
  public isProcessing = false;

  constructor(private route: ActivatedRoute,
              public toastr: ToastrService,
              private authService: AuthService,
              private serviceCopyControllerService: ServiceCopyControllerService) {
    super(toastr);
    this.options = {concurrency: 1, maxUploads: 3};
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.fileIdChanged = new EventEmitter<any>();
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
    });
  }

  public onUploadOutput(output: UploadOutput): void {
    this.isProcessing = true;
    if (output.type === "allAddedToQueue") {
      this.startUpload();
    } else if (output.file && output.file.response) {
      if (output.file.responseStatus) {
        const body = "ok";
        if (output.file.responseStatus >= 400) {
          // Handle all error responses (400, 500, etc.)
          const errorResponse = {status: output.file.responseStatus, message: output.file.response};
          this.fileIdChanged.emit(errorResponse);
          this.resetUploader();
        } else {
          if (output.file.response.catalogs) {
            this.catalogData = output.file.response.catalogs;
            this.serviceCopyId = output.file.response.serviceCopyId;
            this.showImportServiceModal.value = true;
          } else {
            // Success without catalogs - direct import completed
            this.fileIdChanged.emit({ success: true });
            this.resetUploader();
          }
        }
        this.isProcessing = false;
        output.file.response = {status: output.file.responseStatus, message: body};
      }
    }
  }

  private resetUploader(): void {
    this.files = [];
    this.uploadInput.emit({ type: "removeAll" });
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = "";
    }
  }

  private startUpload(): void {
    this.authService.getToken().then((token) => {
      const event: UploadInput = {
        type: "uploadAll",
        url: this.baseUrl + this.serviceUrl,
        headers: {Authorization: "Bearer " + token},
        method: "POST",
      };
      this.uploadInput.emit(event);
      this.isProcessing = false;
    });
  }

  public startCopy(event: any): void {
    if (event.delete || event.cancel) {
      this.showImportServiceModal.value = false;
      this.fileIdChanged.emit({ cancelled: true });
      this.resetUploader();
      return;
    }
    if (event.save && event.catalogsData) {
      const catalogsData = event.catalogsData;
      const jsonData = {serviceCopyId : this.serviceCopyId, catalogs: catalogsData};
      this.serviceCopyControllerService.importServiceWithCatalogs(this.serviceId, jsonData).subscribe(
          () => {
            this.isProcessing = false;
            this.fileIdChanged.emit({ success: true });
            this.resetUploader();
          },
          (error) => {
            this.showErrorMessage(error);
            this.resetUploader();
          },
      );
      this.showImportServiceModal.value = false;
    }
  }
}
